import { transparentize } from 'polished';
import styled from 'styled-components';
import { Colors } from '.';
import { Copy, Flexer, Title } from '../app/dashboard/elements/LayoutElements';

const Icon = styled.div<{ color: string }>`
    padding: .875rem;
    margin-right: 1.25rem;
    color: #ffffff;
    border-radius: 50%;
    border: solid 2px rgba(0,0,0,.05);
    background: ${p => p.color};
`;

const Inner = styled.div<{ expand?: boolean }>`
    flex: ${p => p.expand ? '1 1' : '0 0'} auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    user-select: none;

    ${Title} {
        margin-bottom: .25rem;
    }

    ${Copy} {
        margin: 0;
        line-height: 1.3;
        font-weight: 400;
    }
`;

const Base = styled(Flexer)`
    display: flex;
    padding: 1rem 1.25rem;    
    border: solid 0.0675rem #eeeeee;
    border-radius: 0.25rem;
    cursor: pointer;

    &:hover {
        border-color: ${Colors.hover};
        box-shadow: 0 0 0 .125rem ${Colors.hover};
        background: ${transparentize(.5, Colors.hover)};
    }

    &:active {
        border-color: ${Colors.active};
        box-shadow: 0 0 0 .125rem ${Colors.active};
        background: ${transparentize(.5, Colors.active)};
    }
`;

export const BigButton = Object.assign(Base, { Icon, Inner });
